module.exports = __webpack_public_path__ + "img/tuercas.7b380681.gif";